export class HomeForm{
    automezzo?: string;
    turno?: string;
    data?: Date;
    autista?: string;
    soccorritore1?: string;
    soccorritore2?: string;
    soccorritore3?: string;
}